import {Box, Text} from '@chakra-ui/react';
import {AnimatePresence, motion} from 'framer-motion';
import * as React from 'react';

const MotionedBox = motion(Box);

const Detail = React.forwardRef(({top, opacity, data}, ref) => {
    return (
        <AnimatePresence exitBeforeEnter>
            <MotionedBox
                ref={ref}
                display={'flex'}
                flexDirection={'column'}
                textAlign={'left'}
                maxW={['550px', '443px', '443px', '443px', '550px']}
                pr={['2rem', '2rem', '2rem', '2rem', '2rem']}
                minH={{base: 'auto'}}
                position={{base: 'relative'}}
                style={{
                    opacity,
                }}
                animate={{opacity}}
                // initial={{ opacity: 0, y: 200 }}
                transition={{duration: 0.4}}
                // mt={{base: '80px', lg: '24'}}
                top={{base: 'none'}}
                bottom={{base: 'none', lg: '0'}}
                left={'0'}
            >
                {data?.acf?.quote ?
                <Text
                    as={'h1'}
                    fontSize={'32px'}
                    lineHeight={'120%'}
                    letterSpacing={'-1px'}
                    mb={'20px'}
                    mt={'2.5rem'}
                    fontFamily={'MarkWeb'}
                >
                    {data?.acf?.quote}
                </Text>
                : ''}
                <Box>
                    <Text as={'h2'} fontSize={'12px'} lineHeight={'140%'} mb={'20px'} fontFamily={'MarkWeb'}>
                        {data?.acf?.person_and_company}
                        <br/>
                        <b>{data?.acf?.working_with_line}</b>
                    </Text>

                    <Text as={'p'} fontSize={'lg'} lineHeight={'25.2px'} fontFamily={'MarkWeb'}>
                        <div dangerouslySetInnerHTML={{__html: data?.content?.rendered}}/>
                    </Text>
                </Box>
            </MotionedBox>
        </AnimatePresence>
    );
});
export default Detail;
